import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgDoorWaiting: React.FunctionComponent<
  SVGProps<SVGSVGElement>
> = props => (
  <svg viewBox="0 0 481 512" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#B8B8B8"
        fillRule="nonzero"
        d="M480.38 364.56L241.05 348l-109.67 95h273.2z"
      />
      <path
        d="M332.38 439.62c0-9.14-40.97-17.62-91.5-17.62s-91.5 7.01-91.5 16.16S190.35 451 240.88 451s91.5-2.23 91.5-11.38z"
        fill="#B8B8B8"
        fillRule="nonzero"
      />
      <path
        fill="#007FBF"
        fillRule="nonzero"
        d="M153.7 0l250.68 27.16v415.65L380.82 468 164.2 442.81 131.38 14.4z"
      />
      <path
        fill="#049DFF"
        fillRule="nonzero"
        d="M131.38 14l249 27.15V468l-249-25.2z"
      />
      <path
        fill="#049DFF"
        fillRule="nonzero"
        d="M149.38 40l204 18v385.11l-204-10.11z"
      />
      <path
        stroke="#007FBF"
        strokeWidth={2}
        fill="#049DFF"
        fillRule="nonzero"
        d="M159.38 40l195 19v378l-195-14.44z"
      />
      <path
        d="M334.99 262.62c4.51.48 8.62-6.3 9.24-12.2.62-5.88-.2-12.99-4.71-13.46l-38.71.4c-4.52-.47-7.43 1.77-8.05 7.66-.38 3.65-3.32 6.77-1.28 9.3 1.25 1.55 6.96 2.7 8.68 2.89l34.83 5.41z"
        fill="#007FBF"
        fillRule="nonzero"
      />
      <path
        d="M332.17 260.34c3.04.21 6.08-3.92 7.84-7.2a13.8 13.8 0 0 0 .76-10.98c-1.28-3.5-3.94-5.79-6.99-6l-36.78.9c-2.2-.15-4.06.04-5.48.9-1.07.65-2.58 2.42-4.52 5.32 3.57 5.61 6.93 8.53 10.06 8.75l35.11 8.31z"
        fill="#999"
        fillRule="nonzero"
      />
      <path
        d="M329.01 261.9c3.04.22 6-1.67 7.76-4.96a13.8 13.8 0 0 0 .77-10.98c-1.29-3.5-3.95-5.79-7-6l-36.78.9c-4.7-.32-7.91.91-8.34 6.97-.42 6.06 3.7 7.67 8.4 8l35.2 6.08z"
        fill="#E2E2E2"
        fillRule="nonzero"
      />
      <path
        d="M88 477.81c0-12.6-63.68-32.82 78.63-28.18 142.3 4.65 137.48 19.84 141.42 28.18 3.94 8.34-30.34 22.26-55.67 28.04-40.58 9.27-70.85 4.46-98.11 1.15C101.72 500.62 88 484.64 88 477.81z"
        fill="#000"
        opacity={0.28}
      />
      <path
        d="M122.74 217.35c10.06 1.66 18.51 7.44 26.23 15.27 7.15 7.26 12.82 15.6 17.66 24.67l-52.05 11.37c1.88-9.15-.36-35.74 1.52-44.9 0 0 .73-7.4 6.64-6.41z"
        fill="#FF7C1F"
      />
      <path
        d="M34.22 305.08c36.54-45.73 84.47-59.77 100.6-62.36 68.45-10.97 119.71 25.83 148.06 74.17 39.58 67.5 2.7 142.75-56.93 172.6-62.66 31.36-130.41 18.05-177.37-43.36-20.46-26.76-26.01-51.84-27.84-84.5C5.21 339.3.39 317.37.39 317.37s-6.39-16.4 33.83-12.28z"
        fill="#FF7C1F"
      />
      <path
        d="M225.95 489.48c-51.18 25.62-105.76 21.44-149.63-14.42-6.28-5.13 27.49 30.03 82.35 20.62s74.54-30.3 100.33-51.97c17.2-14.44 30.64-36.51 40.33-66.21 0 22.52-7.16 44.6-21.49 66.21-16.82 25.39-39.25 39.45-51.9 45.77z"
        fill="#E06D17"
      />
      <path
        d="M223.88 350.84c-4.22-8.08-11.21-16.59-13.97-23.78 7.1-.17 18.99 2.6 25.48 4 6.1 1.33 18.45 5.7 19.52 6.46-1.53 3.18-4.07 9.25-5 15.88-.84 6.02-.06 12.6-1.7 16-.72 1.5 1.47-.03 0 .65-1.5.7-21.98-14.73-24.33-19.21z"
        opacity={0.15}
        fill="#000"
      />
      <path
        d="M248.38 369.4c-2.28-7.82-2.98-16.06-3.13-22.32.09-2.23-.28-5.14-.19-7.3-3.55 5.4-6.43 12.47-9.45 19.76-.15.37-.3.78-.18 1.24.1.42.42.79.73 1.1 3.65 3.88 8.03 6.55 12.22 7.53"
        fill="#C6C6C6"
      />
      <path
        d="M231.3 358.02c-8.93-8.77-16.22-19.75-20.5-30.94 7.1-.17 13.8.7 20.3 2.1 6.1 1.33 16.84 6.02 17.91 6.77-2.92 6.07-6.41 13.5-9.86 20.64-.72 1.5-1.52 3.1-3 3.78-1.5.7-3.55-.88-4.85-2.35"
        fill="#FFF"
      />
      <g>
        <path
          d="M194.35 372.63c-15.44 17.44-43.93 17.46-63.64.04-19.7-17.42-23.16-45.68-7.73-63.12 15.44-17.44 43.93-17.46 63.64-.04 19.7 17.42 23.16 45.68 7.73 63.12z"
          opacity={0.2}
          fill="#000"
        />
        <path
          d="M194.35 377.97c-15.44 17.44-43.93 17.46-63.63.04-19.71-17.42-23.17-45.68-7.73-63.12 15.43-17.44 43.92-17.46 63.63-.04 19.7 17.42 23.17 45.68 7.73 63.12z"
          fill="#FFF"
        />
        <path
          d="M161.98 321.84c-3.34 3.77-9.5 3.77-13.76 0-4.26-3.76-5-9.87-1.67-13.64 3.34-3.77 9.5-3.77 13.76 0 4.26 3.76 5 9.87 1.67 13.64z"
          fill="#404040"
        />
        <path
          d="M230.45 266.75c15.99 12.8 23.36 33.7 12.88 44.26-10.48 10.56-30.94 7.55-45.7-6.72-14.75-14.27-18.7-34.87-7.73-44.95 10.02-9.23 24.78-5.2 40.55 7.41z"
          opacity={0.2}
          fill="#000"
        />
        <path
          d="M230.45 272.1c15.99 12.8 23.36 33.69 12.88 44.25-10.48 10.56-30.94 7.55-45.7-6.72-14.75-14.27-18.7-34.87-7.73-44.96 10.02-9.22 24.78-5.2 40.55 7.42z"
          fill="#FFF"
        />
        <path
          d="M211.75 277.74c-3.1 3.43-8.9 3.25-12.92-.4-4.03-3.64-4.77-9.38-1.66-12.8 3.1-3.43 8.9-3.25 12.92.4 4.02 3.64 4.77 9.37 1.66 12.8z"
          fill="#404040"
        />
      </g>
      <g>
        <path
          d="M91.3 419.56s-28.81 5.56-50.54 32.89c0 0 1.12 7.26 15.36 8.97 0 0-2.42 13.13 11.78 5.7 1.08-.58 3.32 5.19 4.52 4.35.67-.47 1.37-.99 2.09-1.55 0 0 9.59 7.27 18.68-8.5 0 0 20.78-30.68-1.9-41.86z"
          opacity={0.22}
          fill="#000"
        />
        <path
          d="M87.35 417.13s-28.8 5.57-50.54 32.9c0 0-4.86 12.93 9.39 14.64 0 0 5.83 17.44 24.36 2.83 0 0 9.6 7.26 18.69-8.5 0 0 20.77-30.68-1.9-41.87z"
          fill="#E86300"
        />
      </g>
      <g transform="translate(183 57)">
        <path stroke="#007FBF" strokeWidth={2} d="M72 7l41 82H31z" />
        <circle fill="#007FBF" cx={72} cy={6} r={5} />
        <circle fill="#F2F2F2" cx={72} cy={5} r={5} />
      </g>
      <g transform="translate(198 81)">
        <ellipse fill="#007FBF" cx={58.5} cy={54.98} rx={52.5} ry={53.5} />
        <ellipse fill="#769237" cx={55.5} cy={53.98} rx={52.5} ry={53.5} />
        <path
          d="M49.99 109.42c28.66 1.38 53.26-21.43 54.94-50.95C106.6 28.95 84.73 3.9 56.07 2.52 27.4 1.14 2.8 23.95 1.13 53.47-.55 82.99 21.33 108.04 50 109.42z"
          fill="#B3D760"
        />
        <path
          d="M50.4 101.43c24.27 1.15 45.1-17.83 46.52-42.38 1.42-24.55-17.1-45.4-41.37-46.54C31.3 11.36 10.47 30.34 9.05 54.9c-1.43 24.55 17.1 45.39 41.36 46.54z"
          fill="#F9F9F9"
        />
        <path
          d="M54.83 15.44a2.5 2.5 0 0 1 2.36 2.62l-.36 7.01a2.5 2.5 0 0 1-2.63 2.37 2.5 2.5 0 0 1-2.37-2.63l.37-7a2.5 2.5 0 0 1 2.63-2.37zM50.82 85.52a2.47 2.47 0 0 1 2.35 2.6l-.35 6.02a2.53 2.53 0 0 1-2.65 2.38 2.47 2.47 0 0 1-2.35-2.61l.36-6.01a2.53 2.53 0 0 1 2.64-2.38zM92 56.64a2.33 2.33 0 0 1-2.45 2.2l-6.37-.3A2.28 2.28 0 0 1 81 56.13a2.33 2.33 0 0 1 2.44-2.2l6.37.3a2.28 2.28 0 0 1 2.17 2.41zM24.1 53.83a2.33 2.33 0 0 1-2.44 2.2l-6.38-.3a2.28 2.28 0 0 1-2.17-2.42 2.33 2.33 0 0 1 2.44-2.2l6.38.3a2.28 2.28 0 0 1 2.17 2.42zM73.59 24.21a.62.62 0 0 1 .19.9l-2.7 3.74a.75.75 0 0 1-.98.2.62.62 0 0 1-.2-.89l2.7-3.74c.23-.31.65-.4.99-.2zM35.32 82.91c.33.23.42.68.22 1.03l-2.74 4.57a.67.67 0 0 1-.95.2.78.78 0 0 1-.22-1.03l2.73-4.57a.67.67 0 0 1 .96-.2zM86.63 38.3c.18.4.03.87-.35 1.09l-4.31 2.48a.7.7 0 0 1-.98-.32.85.85 0 0 1 .35-1.08l4.31-2.48a.7.7 0 0 1 .98.32zM24.45 71.29a.54.54 0 0 1-.25.77l-4.54 1.97a.7.7 0 0 1-.88-.28.54.54 0 0 1 .25-.77l4.54-1.97a.7.7 0 0 1 .88.28zM84.41 76.63a.72.72 0 0 1-.97.2l-4.1-2.58a.67.67 0 0 1-.2-.94.72.72 0 0 1 .97-.2l4.1 2.57a.67.67 0 0 1 .2.95zM26.28 38.64a.72.72 0 0 1-.97.2l-4.1-2.58a.67.67 0 0 1-.2-.94.72.72 0 0 1 .97-.2l4.1 2.57a.67.67 0 0 1 .2.95zM69.73 90.1a.69.69 0 0 1-.94-.3l-2.21-4.52a.73.73 0 0 1 .31-.97.69.69 0 0 1 .94.3l2.22 4.53c.17.35.03.78-.32.97zM38.52 27.64a.69.69 0 0 1-.94-.3l-2.21-4.53a.73.73 0 0 1 .31-.97.69.69 0 0 1 .94.3l2.22 4.53c.17.36.03.79-.32.97z"
          fill="#B8B8B8"
        />
        <path
          d="M73.7 44.28c-.65-.98-8.13 2.57-15.21 7.17-12.24 7.96-12.05 10.52-11.78 10.93.31.48 3.31.61 14.45-6.86 6.66-4.47 13.18-10.26 12.53-11.24z"
          fill="#404040"
        />
        <path
          d="M37.79 27.76c-1.31.68 2.18 10.38 6.93 19.7 8.21 16.11 11.31 16.18 11.87 15.9.63-.34.74-3.55-7.01-18.23-4.64-8.79-10.48-18.05-11.79-17.37z"
          fill="#404040"
        />
      </g>
    </g>
  </svg>
);
/* eslint-enable max-len */

export default SvgDoorWaiting;
